import { isValidHtml, sanitizeHtml, stripHtml } from 'utils/richText'

const QuestionDirections = ({ children }: { children: string }) => {
  if (isValidHtml(children)) {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(children) }}
        className="rich-text-content text-gray-1"
      />
    )
  }

  return <p className="text-gray-1">{stripHtml(children)}</p>
}

export default QuestionDirections
